module.exports = __webpack_public_path__ + "static/img/super-chat-pass.89b5d08f.png";